import { Pipe, PipeTransform } from '@angular/core';
import { MetaDataField } from '../../../../core/infrastructure/classes/meta-data-field';
import { FieldValidatorType } from '../../../../core/infrastructure/enums/field-validator-type.enum';
import { IFieldValidator } from '../../../../core/infrastructure/interfaces/i-field-validator';
import { MaxLengthValidator } from 'src/app/core/infrastructure/classes/metadataDisplayControls/validators/max-length-validator';

@Pipe({
  name: 'dataGetMaxLength'
})

export class DataGetMaxLengthPipe implements PipeTransform {

  transform(col: MetaDataField): number {
    const maxLengthValidator = col?.validators?.find((v: IFieldValidator) => {
      return v.type === FieldValidatorType.MaxLength;
    });

    let max = Number.MAX_VALUE;

    if (maxLengthValidator) {
      max = (maxLengthValidator as MaxLengthValidator).maxLength;
    }

    return max;
  }
}
